import React from 'react';
import { createStyles, makeStyles, SvgIcon, SvgIconProps, Theme } from '@material-ui/core';
import WaitingSVG from './svg-nofill/icon-waiting.svg';

const useIconStyles = makeStyles((theme: Theme) =>
    createStyles({
        icon: {
            '& path:first-child': {
                fill: 'none',
            },
        },
    }),
);

const Waiting: React.FC<SvgIconProps> = (svgIconProps: SvgIconProps) => {
    const classes = useIconStyles();

    return (
        <SvgIcon
            className={classes.icon}
            preserveAspectRatio="xMinYMin meet"
            {...svgIconProps}
            component={WaitingSVG}
        />
    );
};

export default Waiting;
